import { Hook } from 'lib/vendor/terrific/Sandbox';
import { Module } from 'lib/vendor/terrific/Module';

const RES_HOME_ANIMATION = 'res-home-animation';

async function waitForVideoToBeRady(video : HTMLVideoElement) : Promise<void> {
	if (video.readyState === video.HAVE_ENOUGH_DATA || video.networkState === video.NETWORK_NO_SOURCE) {
		return Promise.resolve();
	}
	// Firefox sometimes does not actually loads the data if video is disabled for
	// the page, which is by default. This will prevent the blocking code
	// execution in that rare cases
	if (video.readyState === video.HAVE_FUTURE_DATA && video.networkState === video.NETWORK_IDLE) {
		return Promise.resolve();
	}

	await new Promise(resolve => {
		video.addEventListener('error', resolve, { once: true });
		video.addEventListener('loadeddata', resolve, { once: true });
	});

	return;
}

export default class PortalStage extends Module {
	private animationType! : string;

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {
		this.animationType = this.$ctx.data('animation');

		if(this.animationType === RES_HOME_ANIMATION) {
			setTimeout(() => this.startAnimation());
		}

		callback();
	}

	private async startAnimation() {
		const $videos = this.$ctx.find('video');
		const waitForVideos = $videos.get()
			.map(video => waitForVideoToBeRady(video as HTMLVideoElement));
		await Promise.all(waitForVideos);
		this.$ctx.addClass('start-animation');

		this.$ctx.on('animationend', evt => $(evt.target).addClass('animation-ended'));
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/stage/Tc.Module.PortalStage.ts